var utils = require("../../../utils/utils");
var rowDnd = require("./tasks_grid_dnd");

var initializer = (function(){
	return function(gantt){
		return {
			onCreated: function (grid) {
				grid.$config = utils.mixin(grid.$config, {
					bind: "task"
				});
				if(grid.$config.id == "grid") {
					this.extendGantt(grid);
				}
			},
			onInitialized: function (grid) {
				var config = grid.$getConfig();
				if (config.order_branch) {
					rowDnd.init(grid.$gantt, grid);
				}

				this.initEvents(grid, gantt);
				if(grid.$config.id == "grid") {
					this.extendDom(grid);
				}
			},
			onDestroyed: function (grid) {
				this.clearEvents(grid, gantt);
			},

			initEvents: function (grid, gantt) {
				this._eventHandlers = [];
				var mouseEvents = gantt.$services.getService("mouseEvents");

				this._eventHandlers.push(["click", "gantt_close", gantt.bind(function (e, id, trg) {
					this.close(id);
					return false;
				}, gantt)]);
				this._eventHandlers.push(["click", "gantt_open", gantt.bind(function (e, id, trg) {
					this.open(id);
					return false;
				}, gantt)]);

				this._eventHandlers.push(["click", "gantt_row", gantt.bind(function (e, id, trg) {
					var config = grid.$getConfig();
					if (id !== null) {
						var task = this.getTask(id);
						if (config.scroll_on_click)
							this.showDate(task.start_date);
						gantt.callEvent("onTaskRowClick", [id, trg]);
					}
				}, gantt)]);

				this._eventHandlers.push(["click", "gantt_grid_head_cell", gantt.bind(function (e, id, trg) {
					var column = trg.getAttribute("column_id");

					if (!gantt.callEvent("onGridHeaderClick", [column, e]))
						return;

					var config = grid.$getConfig();

					if (column == "add") {
						mouseEvents.callHandler("click", "gantt_add", undefined, [e, config.root_id]);
						return;
					}

					if (config.sort) {
						var sorting_method = column,
							conf;

						for (var i = 0; i < config.columns.length; i++) {
							if (config.columns[i].name == column) {
								conf = config.columns[i];
								break;
							}
						}

						if (conf && conf.sort !== undefined && conf.sort !== true) {
							sorting_method = conf.sort;

							if (!sorting_method) { // column sort property 'false', no sorting
								return;
							}
						}

						var sort = (this._sort && this._sort.direction && this._sort.name == column) ? this._sort.direction : "desc";
						// invert sort direction
						sort = (sort == "desc") ? "asc" : "desc";
						this._sort = {
							name: column,
							direction: sort
						};
						this.sort(sorting_method, sort == "desc");
					}
				}, gantt)]);
				this._eventHandlers.push(["click", "gantt_add", gantt.bind(function (e, id, trg) {
					var config = grid.$getConfig();
					if (config.readonly) return;

					var item = {};
					this.createTask(item, id ? id : gantt.config.root_id);

					return false;
				}, gantt)]);

				for (var i = 0; i < this._eventHandlers.length; i++) {
					var h = this._eventHandlers[i];
					mouseEvents.delegate(h[0], h[1], h[2], this.$grid);
				}
			},

			clearEvents: function(grid, gantt){
				var mouseEvents = gantt.$services.getService("mouseEvents");
				for(var i = 0; i < this._eventHandlers.length; i++){
					var h = this._eventHandlers[i];
					mouseEvents.detach(h[0], h[1], h[2], grid.$grid);
				}
				this._eventHandlers = [];
			},

			extendDom: function(grid){
				gantt.$grid = grid.$grid;
				gantt.$grid_scale = grid.$grid_scale;
				gantt.$grid_data = grid.$grid_data;
			},
			extendGantt: function(grid){

				gantt.getGridColumns = gantt.bind(grid.getGridColumns, grid);

				grid.attachEvent("onColumnResizeStart", function(){
					return gantt.callEvent("onColumnResizeStart", arguments);
				});
				grid.attachEvent("onColumnResize", function(){
					return gantt.callEvent("onColumnResize", arguments);
				});
				grid.attachEvent("onColumnResizeEnd", function(){
					return gantt.callEvent("onColumnResizeEnd", arguments);
				});

				grid.attachEvent("onColumnResizeComplete", function(columns, totalWidth){
					gantt.config.grid_width = totalWidth;
				});
			}
		};
	};
})();

module.exports = initializer;


//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/grid/main_grid_initializer.js
// module id = 45
// module chunks = 0